// extracted by mini-css-extract-plugin
module.exports = {"page":"_3wiWy6OhH6GkTA-Y-YZyRw==","modal":"QM+XgCDFTcVO3ja9xV06cw=="};